var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.chatTextboxes),function(textbox,index){return _c('div',{key:index,staticClass:"chat-textbox"},[_c('div',{staticClass:"editable-div",attrs:{"contenteditable":"true"},on:{"input":_vm.handleInputChange}},[_vm._v("typing..")])])}),_vm._v(" "),_c('optionspopup',{attrs:{"options":_vm.filteredOptions,"showOptions":_vm.showOptions && _vm.filteredOptions.length > 0,"position":_vm.popupPosition}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84793fea","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/discuss/prac/ChatComponent.vue
// module id = 1011
// module chunks = 0